import { oz } from '@weft/utils';
import { CommercialTermsPricingSchema } from './commercial-terms/commercial-terms-pricing-schema';
import { CommissionPricingSchema } from './fixed-commission/commission-pricing-schema';
import { OneTimePricingSchema } from './fixed-one-time/one-time-pricing-schema';
import { FixedPerUnitPricingSchema } from './fixed-per-unit/fixed-per-unit-pricing-schema';
import { InstallmentsPricingSchema } from './installments/installments-pricing-schema';
import { RefundPricingSchema } from './refund/refund-pricing-schema';
import { SubscriptionPricingSchema } from './subscription/subscription-pricing-schema';

export const FixedPricingSchema = oz.discriminatedUnion('pricingModel', [
  SubscriptionPricingSchema,
  OneTimePricingSchema,
  FixedPerUnitPricingSchema,
  CommercialTermsPricingSchema,
  CommissionPricingSchema,
  InstallmentsPricingSchema,
  RefundPricingSchema,
]).openapi('FixedPricing');

export type FixedPricing = oz.infer<typeof FixedPricingSchema>;